import { render, staticRenderFns } from "./PatientProfileDetails.vue?vue&type=template&id=7b144e4d&scoped=true&lang=pug&"
import script from "./PatientProfileDetails.vue?vue&type=script&lang=js&"
export * from "./PatientProfileDetails.vue?vue&type=script&lang=js&"
import style0 from "./PatientProfileDetails.vue?vue&type=style&index=0&id=7b144e4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b144e4d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VCol,VDivider,VHover,VIcon,VImg,VProgressCircular,VRow,VSkeletonLoader})
